import { render, staticRenderFns } from "./base-menu.vue?vue&type=template&id=71f596a0"
import script from "./base-menu.ts?vue&type=script&lang=ts&external"
export * from "./base-menu.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports